import { useAppDispatch } from '@app/redux/hooks';
import { setInfoCookeis, setCookiesPopup } from '@app/redux/slices/modalWindow';
import styles from './BlockCookies.module.scss';

import Button from '@sharedComponents/CustomButton';

export const BlockCookies = () => {
  const dispatch = useAppDispatch();
  const openModal = () => {
    dispatch(setInfoCookeis(true));
  };

  const closeBlockCookies = () => {
    dispatch(setCookiesPopup(false));
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.text}>
            {' '}
            Мы используем
            <span className={styles.btnModal} onClick={openModal}>
              {' '}
              cookie-файлы{' '}
            </span>
            <span className={styles.textMob}>для вашего удобства пользования сайтом.</span>
          </div>
          <Button value={'Согласен'} onClick={closeBlockCookies} className={styles.btnClose} />
        </div>
      </div>
    </div>
  );
};
